var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3 max-h-80vh overflow-y-auto"},_vm._l((_vm.sortedOptions),function(ref){
var id = ref.id;
var name = ref.name;
var icon = ref.icon;
return _c('base-radio',{key:id,staticClass:"text-gray-dark p-2",attrs:{"id":id,"value":id},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}},[_c('div',{staticClass:"flex gap-2"},[(icon)?_c('div',[_c(icon,{tag:"component"})],1):_vm._e(),_c('div',{staticClass:"text-base"},[_vm._v(_vm._s(name))])])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }